module.exports = __webpack_public_path__ + "static/img/04-07.ffd742b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/04-07.png
// module id = n0Mu
// module chunks = 0